import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {OnlineServiceAuthGuard} from "./common/OnlineServiceAuthGuard";

export const APP_ROUTES: Routes = [
  {path: 'welcome', loadChildren: 'app/welcome/welcome.module#WelcomeModule'},
  {path: 'login', loadChildren: 'app/login/login.module#LoginModule'},
  {path: 'information', loadChildren: 'app/information/information.module#InformationModule'},
  {path: 'createuser', loadChildren: 'app/createuser/createuser.module#CreateUserModule'},
  {path:  'application', loadChildren: 'app/application/application.module#ApplicationModule',canActivate : [OnlineServiceAuthGuard]},
  {path: '', redirectTo: '/welcome', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(APP_ROUTES,{ useHash: true })],
  exports: [RouterModule]
})

export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts